import React from "react";
import "./ChargingPageCustom_Jupiter.css";
import DashboardMain_Jupiter from "../DashboardMain_Jupiter/DashboardMain_Jupiter";
import * as $ from "jquery";
import { useCallback, useContext, useEffect, useState } from "react";
import moment from "moment";
import { INIT_FILTER_STATE } from "../../../constants/driveglobalfilterinitalstates";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";
import useHttp from "../../../hook/use-http";
import AppContext from "../../../store/AppContext";
import ChargingFirstPageFilters_Jupiter from "./ChargingFirstPage_Jupiter/ChargingFirstPageFilter_Jupiter";
import ChargingFirstPageKpis_Jupiter from "./ChargingFirstPage_Jupiter/ChargingFirstPageKpis_Jupiter";
import HighlightsKpis_Jupiter from "./ChargingFirstPage_Jupiter/HightlightsKpis_Jupiter";
import ChargingInterruptionDuration_Jupiter from "./ChargingFirstPage_Jupiter/ChargingInterruptionDuration_Jupiter";
import FastChargeDuration_Jupiter from "./ChargingFirstPage_Jupiter/FastChargeDuration_Jupiter";
import MaxBatteryTemp_Jupiter from "./ChargingFirstPage_Jupiter/MaxBatteryTemp_Jupiter";
import OBCMaxTemp_Jupiter from "./ChargingFirstPage_Jupiter/OBCMaxTemp_Jupiter";
import OBCMaxTempVehicle_Jupiter from "./ChargingFirstPage_Jupiter/OBCMaxTempVehicle_Jupiter";
import MaxBatteryTempVehicleLevel_Jupiter from "./ChargingFirstPage_Jupiter/MaxBatteryTempVehicleLevel_Jupiter";
import SocPerCharge_Jupiter from "./ChargingFirstPage_Jupiter/SocPerCharge_Jupiter";
import MaxCoolentTemp_Jupiter from "./ChargingFirstPage_Jupiter/MaxCoolentTemp_Jupiter";
import FastChargeDurationVehicle_Jupiter from "./ChargingFirstPage_Jupiter/FastChargeDurationVehicle_Jupiter";
import SocPerChargeVehicle_Jupiter from "./ChargingFirstPage_Jupiter/SocPerChargeVehicle_Jupiter";
import ROCFleet_Jupiter from "./ChargingFirstPage_Jupiter/ROCFleet_Jupiter";
import ROCVehicle_Jupiter from "./ChargingFirstPage_Jupiter/ROCVehicle_Jupiter";
import ROCFleetScatter_Jupiter from "./ChargingFirstPage_Jupiter/ROCFleetScatter_Jupiter";
import ROCVehicleScatter_Jupiter from "./ChargingFirstPage_Jupiter/ROCVehicleScatter_Jupiter";
import BMSFleet_Jupiter from "./ChargingFirstPage_Jupiter/BMSFleet_Jupiter";
import BMSVehicle_Jupiter from "./ChargingFirstPage_Jupiter/BMSVehicle_Jupiter";
import BMSFleetScatter_Jupiter from "./ChargingFirstPage_Jupiter/BMSFleetScatter_Jupiter";
import BMSVehicleScatter_Jupiter from "./ChargingFirstPage_Jupiter/BMSVehicleScatter_Jupiter";
import MaxCoolentTempVehicle_Jupiter from "./ChargingFirstPage_Jupiter/MaxCoolentTempVehicle_Jupiter";
import ChargingFirstPageKpisVehicle_Jupiter from "./ChargingFirstPage_Jupiter/ChargingFirstPageKpisVehicle_Jupiter";
import { BsBattery } from "react-icons/bs";

import { useSelector } from "react-redux";
import { selectLoggedInUser } from "../../../redux/userSlice";

export default function ChargingPage_Jupiter() {
  const [gloablfilter, setGloablfilter] = useState(INIT_FILTER_STATE);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);
  const [isOn, setIsOn] = useState();

  const log_data = (data) => {
    //  console.log(data);
  };

  useEffect(() => {
    window.$("#button-1").checked = false;
    fetchData(
      {
        url: API_URL_MAIN + "auth/logging",
        body: {
          page_name: "charginganalysis",
        },
      },
      log_data
    );
  }, []);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0]);
    }
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setFromTableToFilter_vin(vin_num[0]);
    setGloablfilter((prevdata) => {
      return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 };
    });
  };

  const pageChange = () => {
    setGloablfilter((prevdata) => {
      return { ...prevdata, pageSelected: 1, VIN_NUM: [] };
    });
  };

  const onreset = (data) => {
    setGloablfilter(data);
  };

  // code for ROC
  const [chartSelected, setChartSelected] = useState("bar");
  const [type, setType] = useState("Slow");
  const [ROC_SF, setROC_SF] = useState("Slow");
  const changeTB = (selectedOption) => {
    setChartSelected(selectedOption);
  };
  const handleChangeROC = (e) => {
    if (e.target.checked === false) {
      setType("Slow");
      setROC_SF("Slow");
    } else {
      setType("Fast");
      setROC_SF("Fast");
    }
  };
  // code for ROC

  // code for BMS
  const [chartSelectedBMS, setChartSelectedBMS] = useState("bar");
  const [typeBMS, setTypeBMS] = useState("Slow");
  const [BMS_SF, setBMS_SF] = useState("Slow");
  const [chartSelectedBCS, setChartSelectedBCS] =
    useState("Max_BCS_Coolant_In");
  const [typeBCS, setTypeBCS] = useState("Slow");
  const [chartBMSDropdown, setChartBMSDropdown] = useState(
    "BMS_MinCell_Volt"
  );
  // const [BCS_SF, setBCS_SF] = useState('Slow')

  const changeBCS = (selectedOption) => {
    setTypeBCS(typeBCS);
    setChartSelectedBCS(selectedOption);
  };

  const changeBMSDropdown = (selectedOption) => {
    setChartBMSDropdown(selectedOption);
  };

  const changeBMS = (selectedOption) => {
    setTypeBMS(typeBMS);
    setChartSelectedBMS(selectedOption);
  };
  const handleChangeBMS = (e) => {
    if (e.target.checked === false) {
      setTypeBMS("Slow");
      setBMS_SF("Slow");
    } else {
      setTypeBMS("Fast");
      setBMS_SF("Fast");
    }
  };
  // code for BMS

  // code for FCD
  const [typeFCD, setTypeFCD] = useState("Slow");
  const [check, SetCheck] = useState("SC20_100TimeInMin");
  const [chartname, SetChartName] = useState("Slow charge duration 20% - 100%");
  const [API_FCD, SetAPI_FCD] = useState("chargeduration_slow");
  const handleFCD = (e) => {
    if (e.target.checked === false) {
      setTypeFCD("Slow");
      SetCheck("SC20_100TimeInMin");
      SetChartName("Slow charge duration 20% - 100%");
      SetAPI_FCD("chargeduration_slow");
    } else {
      setTypeFCD("Fast");
      SetCheck("FC10_80TimeInMin");
      SetChartName("Fast charge duration 10% - 80%");
      SetAPI_FCD("chargeduration_fast");
    }
  };
  // code for FCD

  // code for max temp
  const [typeMaxTemp, setTypeMaxTemp] = useState("Slow");
  const [chartnameMT, SetChartNameMT] = useState(
    "Max coolant temp(oC) - Slow chrg"
  );
  const handleMaxTemp = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTemp("Slow");
      SetChartNameMT("Max coolant temp(oC) - Slow chrg");
    } else {
      setTypeMaxTemp("Fast");
      SetChartNameMT("Max coolant temp(oC) - Fast chrg");
    }
  };
  // code for max temp

  // code for SOC
  const [typeSOC, setTypeSOC] = useState("Slow");
  const [chartnameSOC, SetChartNameSOC] = useState(
    "SOC per charge - Slow chrg"
  );
  const handleSOC = (e) => {
    if (e.target.checked === false) {
      setTypeSOC("Slow");
      SetChartNameSOC("SOC per charge - Slow chrg");
    } else {
      setTypeSOC("Fast");
      SetChartNameSOC("SOC per charge - Fast chrg");
    }
  };
  // code for SOC

  // code for max Battery temp
  const [typeMaxTempBattery, setTypeMaxTempBattery] = useState("Slow");
  const [chartnameMaxTempBattery, SetChartNameMaxTempBattery] = useState(
    "Max HV battery temp - Slow chrg"
  );
  const handleMaxTempBattery = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTempBattery("Slow");
      SetChartNameMaxTempBattery("Max HV battery temp - Slow chrg");
    } else {
      setTypeMaxTempBattery("Fast");
      SetChartNameMaxTempBattery("Max HV battery temp - Fast chrg");
    }
  };
  const loggedInUser = useSelector(selectLoggedInUser);
  // code for max Battery temp

  const [showChargingInterruption, setShowChargingInterruption] =
    useState(true);
  const toggleChargingInterruption = () => {
    setShowChargingInterruption(!showChargingInterruption);
  };
  return (
    <>
      <DashboardMain_Jupiter>
        <ChargingFirstPageFilters_Jupiter
          onsubmit={filterSubmited}
          gloablfilter={gloablfilter}
          onreset={onreset}
          fromTableToFilter_vin={fromTableToFilter_vin}
        />

        <div className="container-fluid">
          {gloablfilter.VIN_NUM.length === 1 ? (
            <ChargingFirstPageKpisVehicle_Jupiter gloablfilter={gloablfilter} />
          ) : (
            <ChargingFirstPageKpis_Jupiter gloablfilter={gloablfilter} />
          )}
          {loggedInUser.flagForHideShow === "ERC" && (
            <section className="highlights">
              <div className="row">
                <HighlightsKpis_Jupiter
                  gloablfilter={gloablfilter}
                  toggleChargingInterruption={toggleChargingInterruption}
                />
                {showChargingInterruption && (
                  <ChargingInterruptionDuration_Jupiter
                    gloablfilter={gloablfilter}
                    singleVinSelected={singleVinSelected}
                  />
                )}
              </div>
            </section>
          )}
          <section className="graphs">
            <div className="row mt-2 mb-3">
              <div className="col-lg-3 col-md-6 col-sm-12 pr-0 mb-3">
                <div className="chargingChartbox wd_4_charts">
                  <div className="v-title chargingTitleChart">
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2">
                          <b>{chartname}</b>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <div className="toggleBtn pt-0">
                          <div className="toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1">
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  onChange={handleFCD}
                                />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT">
                    {gloablfilter.VIN_NUM.length === 1 ? (
                      <FastChargeDurationVehicle_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="fastchargedurationdehicleslow"
                        type={typeFCD}
                      />
                    ) : (
                      <FastChargeDuration_Jupiter
                        gloablfilter={gloablfilter}
                        apiend={API_FCD}
                        type={typeFCD}
                        checkFCD={check}
                        chartnameFCD={chartname}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12 pr-0 mb-3">
                <div className="chargingChartbox wd_4_charts">
                  <div className="v-title chargingTitleChart">
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2">
                          <b>{chartnameMaxTempBattery}</b>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <div className="toggleBtn pt-0">
                          <div className=" toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1">
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  onChange={handleMaxTempBattery}
                                />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT">
                    {gloablfilter.VIN_NUM.length === 1 ? (
                      <MaxBatteryTempVehicleLevel_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="maxbatterytempVehiclelevelslow"
                        type={typeMaxTempBattery}
                      />
                    ) : (
                      <MaxBatteryTemp_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="maxbatterytempslow"
                        type={typeMaxTempBattery}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-3 col-md-6 col-sm-12 pr-0 mb-3">
                <div className="chargingChartbox wd_4_charts">
                  <div className="v-title chargingTitleChart">
                    <div className="row ">
                      <div className="col-lg-9 col-sm-9">
                        <div className="p-2 text-start">
                          <b>OBC max temp - Slow chrg</b>
                        </div>
                      </div>
                      <div className="col-lg-3 col-sm-3 text-end">
                        <div className="toggleBtn">
                          <div className=" toggle-button-cover">
                            <div className="button-cover"></div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT">
                    {gloablfilter.VIN_NUM.length === 1 ? (
                      <OBCMaxTempVehicle_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="OBC_max_temp_slow_chrg_vehicle_slow"
                      />
                    ) : (
                      <OBCMaxTemp_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="OBC_max_temp_slow_chrg_fleet_slow"
                      />
                    )}
                  </div>
                </div>
              </div>
              {loggedInUser.flagForHideShow === "ERC" ? (
                <div className="col-lg-3 col-md-6 col-sm-12">
                  <div className="chargingChartbox wd_4_charts">
                    <div className="v-title chargingTitleChart">
                      <div className="row">
                        <div className="col-lg-5 col-md-6 col-sm-5 col-5">
                          <div className="p-2">
                            <b>ROC - {ROC_SF} chrg</b>
                          </div>
                        </div>
                        <div className="col-lg-7 col-md-6 col-sm-7 col-7">
                          <div className="row">
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                              <div className="dropdownSelectBtnCharging">
                                <select
                                  className="form-select form-select-sm"
                                  aria-label=".form-select-sm example"
                                  onChange={(event) =>
                                    changeTB(event.target.value)
                                  }
                                  value={chartSelected}
                                >
                                  <option value="bar">Bar</option>
                                  <option value="scatter">Scatter</option>
                                </select>
                              </div>
                            </div>
                            <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                              <div className="toggleBtn pt-0">
                                <div className="toggle-button-cover">
                                  <div className="button-cover">
                                    <div className="buttonbtn r" id="button-1">
                                      <input
                                        type="checkbox"
                                        className="checkbox"
                                        onChange={handleChangeROC}
                                      />
                                      <div className="knobs" />
                                      <div className="layer" />
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="chargingChartHGT">
                      {chartSelected === "bar" ? (
                        gloablfilter.VIN_NUM.length === 1 ? (
                          <ROCVehicle_Jupiter
                            gloablfilter={gloablfilter}
                            apiend="ROC_vehicle"
                            type={type}
                          />
                        ) : (
                          <ROCFleet_Jupiter
                            gloablfilter={gloablfilter}
                            apiend="ROC_fleet"
                            type={type}
                          />
                        )
                      ) : gloablfilter.VIN_NUM.length === 1 ? (
                        <ROCVehicleScatter_Jupiter
                          apiend="ROC_vehicle_scatter"
                          type={type}
                          gloablfilter={gloablfilter}
                        />
                      ) : (
                        <ROCFleetScatter_Jupiter
                          apiend="ROC_fleet"
                          type={type}
                          gloablfilter={gloablfilter}
                        />
                      )}
                    </div>
                  </div>
                </div>
              ) : (
                <ChargingInterruptionDuration_Jupiter
                  gloablfilter={gloablfilter}
                  singleVinSelected={singleVinSelected}
                />
              )}
            </div>
            <div className="row mb-3">
              <div className="col-lg-4 col-md-6 col-sm-12 pr-0 mb-3">
                <div className="chargingChartbox wd">
                  <div className="v-title chargingTitleChart">
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2">
                          <b>{chartnameSOC}</b>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <div className="toggleBtn pt-0">
                          <div className=" toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1">
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  onChange={handleSOC}
                                />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT">
                    {gloablfilter.VIN_NUM.length === 1 ? (
                      <SocPerChargeVehicle_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="socpervehicleslow"
                        type={typeSOC}
                      />
                    ) : (
                      <SocPerCharge_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="socperchargeslow"
                        type={typeSOC}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 pr-0 mb-3">
                <div className="chargingChartbox wd">
                  <div className="v-title chargingTitleChart">
                    <div className="row">
                      <div className="col-lg-6 col-md-9 col-sm-9 col-9">
                        <div className="pt-2 pl-2">
                          <b>{chartnameMT}</b>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <div className="dropdownBCSSelectBtnCharging">
                          <select
                            className="form-select form-select-sm mt-1"
                            aria-label=".form-select-sm example"
                            onChange={(event) => changeBCS(event.target.value)}
                            value={chartSelectedBCS}
                          >
                            <option value="Max_BCS_Coolant_In">
                              Max BCS Coolant In
                            </option>
                            <option value="Max_BCS_Coolant_Out">
                              Max BCS Coolant Out
                            </option>
                          </select>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <div className="toggleBtn pt-0">
                          <div className="toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1">
                                <input
                                  type="checkbox"
                                  className="checkbox"
                                  onChange={handleMaxTemp}
                                />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT">
                    {gloablfilter.VIN_NUM.length === 1 ? (
                      <MaxCoolentTempVehicle_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="maxcoolentvehiclelevelslow"
                        type={typeMaxTemp}
                        chartSelectedBCS={chartSelectedBCS}
                      />
                    ) : (
                      <MaxCoolentTemp_Jupiter
                        gloablfilter={gloablfilter}
                        apiend="maxcoolenttempslow"
                        type={typeMaxTemp}
                        chartSelectedBCS={chartSelectedBCS}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 mb-3">
                <div className="chargingChartbox wd">
                  <div className="v-title chargingTitleChart">
                    <div className="row">
                      <div className="col-lg-4 col-md-5 col-sm-5 col-5">
                        <div className="p-2">
                          <b>BMS cell voltage - {BMS_SF} chrg</b>
                        </div>
                      </div>
                      <div className="col-lg-8 col-md-7 col-sm-7 col-7">
                        <div className="row">
                          <div className="col-lg-4 col-md-7 col-sm-6 col-6">
                            <div className="dropdownSelectBtnCharging">
                              <select
                                className="form-select form-select-sm mt-1"
                                aria-label=".form-select-sm example"
                                onChange={(event) =>
                                  changeBMSDropdown(event.target.value)
                                }
                                value={chartBMSDropdown}
                              >
                                <option value="BMS_MinCell_Volt">
                                  Min voltage
                                </option>
                                <option value="BMS_MaxCellVolt">
                                  Max voltage
                                </option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-7 col-sm-6 col-6">
                            <div className="dropdownSelectBtnCharging">
                              <select
                                className="form-select form-select-sm mt-1"
                                aria-label=".form-select-sm example"
                                onChange={(event) =>
                                  changeBMS(event.target.value)
                                }
                                value={chartSelectedBMS}
                              >
                                <option value="bar">Bar</option>
                                <option value="scatter">Scatter</option>
                              </select>
                            </div>
                          </div>

                          <div className="col-lg-4 col-md-5 col-sm-6 col-6">
                            <div className="toggleBtn pt-0">
                              <div className=" toggle-button-cover">
                                <div className="button-cover">
                                  <div className="buttonbtn r" id="button-1">
                                    <input
                                      type="checkbox"
                                      className="checkbox"
                                      onChange={handleChangeBMS}
                                    />
                                    <div className="knobs" />
                                    <div className="layer" />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="chargingChartHGT">
                    {chartSelectedBMS === "bar" ? (
                      gloablfilter.VIN_NUM.length === 1 ? (
                        <BMSVehicle_Jupiter
                          gloablfilter={gloablfilter}
                          apiend="BMS_vehicle"
                          type={typeBMS}
                          chartBMSDropdown={chartBMSDropdown}
                        />
                      ) : (
                        <BMSFleet_Jupiter
                          gloablfilter={gloablfilter}
                          apiend="BMS_fleet"
                          type={typeBMS}
                          chartBMSDropdown={chartBMSDropdown}
                        />
                      )
                    ) : gloablfilter.VIN_NUM.length === 1 ? (
                      <BMSVehicleScatter_Jupiter
                        apiend="BMS_vehicle_scatter"
                        type={typeBMS}
                        gloablfilter={gloablfilter}
                        chartBMSDropdown={chartBMSDropdown}
                      />
                    ) : (
                      <BMSFleetScatter_Jupiter
                        apiend="BMS_fleet"
                        type={typeBMS}
                        gloablfilter={gloablfilter}
                        chartBMSDropdown={chartBMSDropdown}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </DashboardMain_Jupiter>
    </>
  );
}
